var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "22",
        viewBox: "0 0 16 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_295_490)" } }, [
        _c("path", {
          attrs: {
            d: "M14.438 1.75537C14.438 1.02939 13.8515 0.442871 13.1255 0.442871H2.62553C1.89955 0.442871 1.31303 1.02939 1.31303 1.75537C1.31303 2.48135 1.89955 3.06787 2.62553 3.06787H3.83549L3.36791 9.14639C1.86263 9.9626 0.673182 11.3284 0.107166 13.0306L0.0661507 13.1536C-0.0692005 13.5556 0.000525475 13.9944 0.246619 14.3349C0.492713 14.6753 0.890565 14.8804 1.31303 14.8804H14.438C14.8605 14.8804 15.2542 14.6794 15.5044 14.3349C15.7546 13.9903 15.8203 13.5515 15.6849 13.1536L15.6439 13.0306C15.0779 11.3284 13.8884 9.9626 12.3831 9.14639L11.9156 3.06787H13.1255C13.8515 3.06787 14.438 2.48135 14.438 1.75537ZM9.18803 16.1929H6.56303V20.1304C6.56303 20.8563 7.14955 21.4429 7.87553 21.4429C8.6015 21.4429 9.18803 20.8563 9.18803 20.1304V16.1929Z",
            fill: "black",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_295_490" } }, [
          _c("rect", {
            attrs: {
              width: "15.75",
              height: "21",
              fill: "white",
              transform: "matrix(-1 0 0 1 15.75 0.442871)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }